// NEXT_PUBLIC_* values are inlined at build time, so this must be set in the pipeline variables.
export const isWebCandidateLoginEnabled = process.env.NEXT_PUBLIC_WEB_CANDIDATE_LOGIN_ENABLED === 'true'
